var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "white",
    opacity: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.788 15.707C14.0295 15.888 14.3407 15.9333 14.6182 15.8221C14.8957 15.7102 15.0997 15.4592 15.1612 15.1551C15.8129 11.9119 17.3939 3.70309 17.9871 0.752942C18.0321 0.530589 17.9571 0.2995 17.7921 0.151C17.6271 0.00250011 17.3984 -0.0403824 17.1944 0.0398236C14.0497 1.2723 4.3652 5.1198 0.406789 6.67071C0.155545 6.76918 -0.00795143 7.02489 0.000298384 7.30521C0.00929818 7.58633 0.187794 7.83013 0.445038 7.91192C2.22025 8.47416 4.55044 9.25636 4.55044 9.25636C4.55044 9.25636 5.63942 12.7386 6.20716 14.5095C6.27841 14.7318 6.44265 14.9065 6.6594 14.9669C6.87539 15.0264 7.10639 14.9637 7.26763 14.8025C8.17961 13.8908 9.58958 12.4813 9.58958 12.4813C9.58958 12.4813 12.2685 14.5611 13.788 15.707ZM5.53067 8.81642L6.78989 13.2142L7.06964 10.4293C7.06964 10.4293 11.9348 5.78289 14.7082 3.1345C14.7892 3.05668 14.8005 2.92644 14.733 2.83512C14.6662 2.7438 14.5432 2.72236 14.451 2.7843C11.2365 4.9578 5.53067 8.81642 5.53067 8.81642Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.29d4bef6.svg";
export { ForwardRef as ReactComponent };